import styled from 'styled-components';
import { SummaryDiscountDetailsStyled } from '../SummaryDiscountDetailsStyled';

export const SummaryDiscountDetailsAP = styled(SummaryDiscountDetailsStyled)``;
